import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=41e8f339&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=js&"
export * from "./Gift.vue?vue&type=script&lang=js&"
import style0 from "./Gift.vue?vue&type=style&index=0&id=41e8f339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e8f339",
  null
  
)

export default component.exports